export const phoneRegex = /^[+\d/\-. ]*$/gm;
